<script>
import ratingFormatter from "@/utils/formatters/rating";

export default {
  props: {
    rating: {
      type: Number,
      required: true
    }
  },
  filters: {
    intToRating(rating) {
      return ratingFormatter.intToRating(rating);
    }
  }
};
</script>

<template>
  <section>
    <div class="bg-rating">
      <div class="stars" :style="`width: ${rating / 100}%`"></div>
    </div>
    <b>| {{rating | intToRating}}</b>
  </section>
</template>

<style scoped>
section {
  margin: 5px 0;
  display: flex;
  flex-direction: row;
}

b {
  margin-left: 5px;
  font-size: 13px;
}

.bg-rating {
  background: url("https://res.cloudinary.com/joaofnds/image/upload/v1548201143/email%20donamaid/estrela_contorno-01.png")
    no-repeat;
  width: 69px;
  height: 11px;
}

.stars {
  background: url("https://res.cloudinary.com/joaofnds/image/upload/v1548201143/email%20donamaid/estrela_color-01.png")
    no-repeat;
  max-width: 69px;
  height: 11px;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Professionals/Stars.vue